import { render, staticRenderFns } from "./CalculatorCounter.vue?vue&type=template&id=572e6e10&scoped=true"
import script from "./CalculatorCounter.vue?vue&type=script&lang=ts"
export * from "./CalculatorCounter.vue?vue&type=script&lang=ts"
import style0 from "./CalculatorCounter.vue?vue&type=style&index=0&id=572e6e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572e6e10",
  null
  
)

export default component.exports